/*global jQuery:readonly */
import * as React from "react";
import { Route, Switch } from "react-router-dom";

import { Place, PlaceGroup, UserSummary } from "../data";
import { checkLogin } from "../helpers";

import Home from "./Home";
import Nav from "./Nav";
import { EventEditor } from "./EventEditor";
import { SitrepAdmin } from "./SitrepAdmin/SitrepAdmin";
import NewUsers from "./NewUsers";
import RegionEditor from "./RegionEditor";
import StatEditor from "./StatEditor";
import UserAdmin from "./UserAdmin";
import Validate from "./Validate";

interface ToolboxState {
    countries: Place[];
    events: string[];
    globalMods: UserSummary[];
    isGlobalMod: boolean;
    modRegions: {[key: number]: boolean};
    places: PlaceGroup[];
    regionStats: {[key: number]: number};
    timezones: string[];
}

class Toolbox extends React.Component<{}, ToolboxState> {
    state: ToolboxState = {
        countries: [],
        events: [],
        globalMods: [],
        isGlobalMod: false,
        modRegions: {},
        places: [],
        regionStats: {},
        timezones: [],
    };

    componentDidMount() {
        jQuery.getJSON("/backend/toolbox/bootstrap").then(
            (data): void  => {
                this.setState({
                    countries: data.countries,
                    events: data.events,
                    globalMods: data.global_mods,
                    isGlobalMod: data.is_global_mod,
                    modRegions: data.mod_regions.reduce((a, v): any => { a[v] = true; return a; }, {}),
                    places: data.places,
                    regionStats: data.region_stats,
                    timezones: data.timezones,
                });
            },
            checkLogin
        );
    }

    render() {
        return (
            <div>
                <Nav isGlobalMod={ this.state.isGlobalMod } />
                <Switch>
                    <Route exact={ true } path="/toolbox" component={ Home } />
                    <Route
                        path="/toolbox/eventeditor"
                        render={ (): JSX.Element => <EventEditor isGlobalMod={ this.state.isGlobalMod } events={ this.state.events } /> }
                    />
                    <Route
                        path="/toolbox/newusers"
                        render={ (): JSX.Element => <NewUsers countries={ this.state.countries } places={ this.state.places } /> }
                    />
                    <Route
                        path="/toolbox/regioneditor/:countryId?/:placeId?"
                        render={ (props): JSX.Element => {
                            return (
                                <RegionEditor
                                    countries={ this.state.countries }
                                    countryId={ props.match.params.countryId }
                                    globalMods={ this.state.globalMods }
                                    history={ props.history }
                                    isGlobalMod={ this.state.isGlobalMod }
                                    modRegions={ this.state.modRegions }
                                    placeId={ props.match.params.placeId }
                                    places={ this.state.places }
                                    regionStats={ this.state.regionStats }
                                />);
                        } }
                    />
                    <Route
                        path="/toolbox/stateditor/:userId?/:id?"
                        render={ (props): JSX.Element => {
                            return (
                                <StatEditor
                                    history={ props.history }
                                    userId={ props.match.params.userId }
                                    statId={ props.match.params.id }
                                />);
                        } }
                    />
                    <Route
                        path="/toolbox/useradmin/:id?"
                        render={ (props): JSX.Element => {
                            return (
                                <UserAdmin
                                    countries={ this.state.countries }
                                    history={ props.history }
                                    isGlobalMod={ this.state.isGlobalMod }
                                    places={ this.state.places }
                                    userId={ props.match.params.id }
                                    timezones={ this.state.timezones }
                                />);
                        } }
                    />
                    <Route path="/toolbox/validate" component={ Validate } />
                    <Route path="/toolbox/sitrepadmin" component={ SitrepAdmin } />
                </Switch>
            </div>
        );
    }
}

export default Toolbox;
